document.querySelectorAll('.IndexMainFilters').forEach((el) => {
    const filterTypeHouse = el.querySelector('.FilterTypeHouse');
    const elsHide = document.querySelectorAll('.ModalAllFilters *[data-type-hide], .IndexMainFilters *[data-type-hide]');
    const elsShow = document.querySelectorAll('.ModalAllFilters *[data-type-show], .IndexMainFilters *[data-type-show]');
    const selectAddress = document.querySelector('.IndexMainFilters__address .SearchableInput');
    const toggleBtn = document.querySelectorAll('*[data-toggle]');
    const resetBtnEl = document.querySelector('.reset-main-filter');

    const typesElsHide = getElsTypes(elsHide);
    const typesElsShow = getElsTypes(elsShow);

    const active = Array.from(filterTypeHouse.querySelectorAll('input:checked')).map((input) => input.value);
    select(active);

    el.querySelectorAll('.IndexMainFilters__close').forEach((btn) => {
        btn.addEventListener('click', () => {
            el.parentElement.classList.remove('active');
            closeModal(el.parentElement);
        });
    })

    document.addEventListener('main-filter-update', ({ detail: filters }) => {
        const state = Object.keys(filters).some((name) => {
            if (name === 'general-category' || name === 'general-type') {
                return Array.isArray(filters[name]) ? filters[name].length : filters[name];
            }
        });
        resetBtnEl.classList.toggle('active', state);
    });

    if (selectAddress) {
        selectAddress.addEventListener('select', (e) => {
            const item = e.detail;
            citySet(item && item.innerText, item && item.dataset.value, false);
        });
    }

    toggleBtn.forEach((btn) => {
        btn.addEventListener('click', () => {
            toggleElHandle(btn);
        });
        btn.addEventListener('close', () => {
            toggleElHandle(btn, false);
        });
    })

    function toggleElHandle(btn, state) {
        const el = document.querySelector(btn.dataset.toggle);
        if (el) {
            el.classList.add('animation');
            setTimeout(() => el.classList.toggle('active', state), 1);
            setTimeout(() => el.classList.remove('animation'), 500);
        }
    }

    function toggleEl(els, type, hide = true) {
        if (els) {
            els.forEach((el) => {
                if (hide) {
                    el.setAttribute('data-type-hidden', 1);
                } else {
                    el.removeAttribute('data-type-hidden');
                }
            })
        } else {
            console.warn('not found', type);
        }
    }

    function showAll() {
        Object.keys(typesElsHide).forEach((type) => {
            toggleEl(typesElsHide[type], type, false);
        })
    }

    filterTypeHouse.addEventListener('select', (e) => {
        select(e.detail);
    });

    function select(typesActive) {
        showAll();
        Object.keys(typesElsShow).forEach((type) => {
            if (!typesActive.includes(type)) {
                toggleEl(typesElsShow[type], type, true);
            }
        });
        Object.keys(typesElsShow).forEach((type) => {
            if (typesActive.includes(type)) {
                toggleEl(typesElsShow[type], type, false);
            }
        });

        //Должны быть только типы, которые скрывают, если выбран хоть один тип который не скрывает, оставляем видимым
        elsHide.forEach((el) => {
            const typesEl = el.dataset.typeHide.split(',');
            const isAllTypesInHide = typesActive.every((type) => typesEl.includes(type));
            console.log(el, typesEl, typesActive, isAllTypesInHide);
            if(isAllTypesInHide) {
                toggleEl([el], typesEl, true);
            }
        });
    }

    function getElsTypes(els) {
        return Array.from(els).reduce((tmp, el) => {
            const type = el.dataset.typeHide || el.dataset.typeShow;
            type.split(',').forEach((type) => {
                if (!tmp[type]) tmp[type] = [];
                tmp[type].push(el);
            });
            return tmp;
        }, {});
    }
});
document.querySelectorAll('.IndexMainFilters__other .tag--close').forEach((tag) => {
    const inputs = Array.from(document.querySelectorAll('.IndexMainFilters input, .ModalSelectMetro input, .ModalSelectDistrict input, .ModalAllFilters input'));

    inputs.forEach((input) => {
        input.addEventListener('input', updateCount);
    });
    updateCount();

    function updateCount() {
        const count = inputs.reduce((tmp, input) => tmp + (isInputNotEmpty(input) ? 1 : 0), 0);
        tag.innerHTML = count ? count.toString() : '';
    }

    tag.addEventListener('click', () => {
        inputs.forEach((input) => {
            if (isInputBoolean(input)) {
                if (input.checked) {
                    input.click();
                    input.checked = false;
                }
            } else {
                if (input.value) {
                    input.value = '';
                }
            }
        });
        tag.innerHTML = '';

        document.querySelectorAll('.HeaderSC__filters .HeaderSC__tag').forEach((tag) => {
            tag.click();
        });
    });
})

function isInputBoolean(input) {
    return input.type === 'radio' || input.type === 'checkbox';
}

function isInputNotEmpty(input) {
    if (isInputBoolean(input)) {
        return input.checked;
    } else {
        return input.value;
    }
}
